<!-- eslint-disable -->
<template lang="pug">
    .app-header
        .app-header__content(:class="{'app-header__content--columned': isGameHeaderVisible}")
            .app-header__column.app-header__column--left(:class="{'app-header__column--full-width': isGameHeaderVisible}")
                slot(name="left")
            .app-header__column.app-header__column--center(v-if="!isGameHeaderVisible")
                slot(name="center")
            .app-header__column.app-header__column--right(
                :class="{\
                    'app-header__column--visible': isGameHeaderVisible,\
                    'app-header__column--full-width': isGameHeaderVisible\
                }"
            )
                slot(name="right")
</template>

<script>
    /*eslint-disable*/
    /**
     * Used as header in templates.
     */
    export default {
        name: 'AppHeader',
        status: 'ready',
        release: '1.0.0',
        computed: {
            isGameHeaderVisible () {
                return this.$route.name.includes(':start') || this.$route.name === 'abacus';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .app-header__content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        user-select: none;
    }

    .app-header__content--columned {
        flex-direction: column;
        justify-content: space-between;
        @include media($md) {
            flex-direction: row;
            justify-content: flex-start;
        }
    }

    .app-header__column {
        padding: 24px 0;
        display: block;
        box-sizing: border-box;
        flex-basis: 0;
        flex-grow: 1;
        flex-shrink: 1;
    }

    .app-header__column--left {
        @include media($md) {
            flex-grow: 0;
        }
    }

    .app-header__column--center {
        text-align: left;
        display: none;
        @include media($md) {
            display: flex;
        }
    }

    .app-header__column--right {
        text-align: right;
        display: none;
        @include media($md) {
            display: block;
        }
    }
    .app-header__column--visible {
        display: block;
        padding: 0 0 24px 0;
        @include media($md) {
            padding: 0;
        }
    }
    .app-header__column--full-width {
        width: 100%;
        @include media($md) {
            width: auto;
        }
    }
</style>
